import { T_FAQ_PAGE_CONSTANTS } from './TYPES'

const FR_FAQ_PAGE_CONSTANTS: T_FAQ_PAGE_CONSTANTS = {
  PAGE_KICKER: 'AIDEZ-VOUS AVEC',
  PAGE_TITLE: 'Questions Fréquemment Posées',
  FAQ_CATEGORIES: [
    {
      categoryName: 'Général',
      faqs: [
        {
          question: 'Quel est le but de cette application?',
          answer:
            "Cette application est conçue pour encourager la lecture chez les enfants de manière ludique et engageante. Les enfants, appelés Aventuriers, lisent des livres hors ligne et répondent à des quiz basés sur leurs lectures. En accumulant des points, ils aident leur mascotte, un griffon nommé Griffy, à évoluer et à monter de niveau, rendant l'expérience encore plus motivante. L'application fait la distinction entre les utilisateurs enfants et les utilisateurs adultes. Les Aventuriers peuvent jouer seuls, participer à des événements ou compétitions de lecture, et se connecter avec leurs amis en leur envoyant des demandes. Ils peuvent aussi voir la bibliothèque de leurs amis, ce qui favorise l'échange de livres et renforce la communauté autour de la lecture. Les utilisateurs adultes peuvent, quant à eux, créer et télécharger des quiz, ainsi qu'organiser des événements ou compétitions de lecture pour les Aventuriers. Cette approche collaborative soutient une lecture à la fois autonome et accompagnée, afin de nourrir l'amour des livres."
        },
        {
          question: 'Qui peut utiliser cette application ?',
          answer:
            "L'application peut être utilisée par les adultes et les enfants (nommés aventuriers)."
        },
        {
          question: 'Que peut faire un adulte sur la plateforme ?',
          answer:
            "Les adultes - parents, enseignants - peuvent ajouter des quiz de livres, ce qui contribuera à enrichir la bibliothèque de contenus éducatifs. Ils peuvent également organiser des événements et compétitions de lecture pour un groupe d'enfants afin de promouvoir la lecture tout en suivant leurs progrès et leurs accomplissements."
        },
        {
          question: 'Que peut faire un enfant sur la plateforme ?',
          answer:
            'Les enfants peuvent passer des quiz, noter et suivre leurs livres, gérer leur bibliothèque et interagir avec leurs amis. Ils peuvent participer à trois modes de jeu : aventure en solo, compétitions sur invitation et événements publics.'
        },
        {
          question:
            'Comment puis-je créer un compte pour moi-même et pour mon (mes) enfant(s) ?',
          answer:
            "Vous pouvez créer un compte en saisissant votre nom complet, votre date de naissance, votre langue préférée, votre adresse e-mail et un mot de passe à 6 chiffres. Une fois votre compte créé, vous pouvez ajouter un compte pour votre (vos) enfant(s) en cliquant sur le bouton « Ajouter un enfant » et en indiquant son (leurs) nom complet, date de naissance, langue préférée, nom d'utilisateur et un mot de passe à 6 chiffres."
        }
      ]
    },
    {
      categoryName: 'Compte et Abonnement',
      faqs: [
        {
          question: "Y a-t-il des frais d'abonnement ?",
          answer:
            "La plateforme est gratuite pour les adultes. Un petit abonnement est requis pour débloquer l'accès à la plateforme pour les enfants. Plusieurs formules d'abonnement sont disponibles, en fonction du nombre d'enfants à inscrire et de la durée de l'abonnement. Le paiement se fait via PayPal. Pendant la phase bêta, l'accès est gratuit au plateforme."
        },
        {
          question: "Y a-t-il une période d'essai gratuite pour les enfants ?",
          answer:
            "Oui, il y a une période d'essai de 15 jours pour les enfants, après laquelle un adulte devra abonner l'enfant à un plan d'abonnement."
        },
        {
          question: "Quels sont les avantages de l'abonnement ?",
          answer:
            "L'abonnement débloque toutes les fonctionnalités de la plateforme, y compris la possibilité de participer à des compétitions, de consulter les classements et de recevoir des badges pour les meilleurs classements."
        }
      ]
    },
    {
      categoryName: 'Jeu et Fonctionnalités',
      faqs: [
        {
          question: 'Comment fonctionnent les quiz ?',
          answer:
            "Les quiz sont des tests à choix multiples visant à évaluer la compréhension du texte d'un livre lu hors ligne. Chaque quiz se compose de 5 questions, avec trois options de réponse par question : une correcte et deux incorrectes. Des points peuvent être gagnés en sélectionnant la bonne réponse (5 points par question, avec un maximum de 25 points par quiz), qui contribuent à l'expérience du personnage, menant à la montée en niveau et à l'évolution de son Griffy."
        },
        {
          question: 'Les enfants peuvent-ils faire des concours entre eux ?',
          answer:
            'Oui, les adultes peuvent créer des compétitions auxquelles les enfants peuvent participer. Les classements apparaissent sur un tableau des leaders, et des badges sont attribués aux meilleurs résultats. Les enfants peuvent aussi participer à des événements organisés par le plateforme.'
        },
        {
          question:
            'Comment les enfants peuvent-ils devenir ami(e)s sur le plateforme ?',
          answer:
            "Les enfants peuvent ajouter d'autres enfants à leur liste d'amis. Ils peuvent également voir les livres possédés par leurs amis pour faciliter les contacts et les discussions hors ligne."
        }
      ]
    },
    {
      categoryName: 'Livres et Lecture',
      faqs: [
        {
          question:
            "Les enfants peuvent-ils indiquer quels livres ils possèdent dans l'application ?",
          answer:
            "Les enfants peuvent indiquer, dans la section « Ma bibliothèque » de l'application, les livres disponibles dans leur bibliothèque à la maison. Ainsi, leurs amis peuvent également voir quels livres ils possèdent et s'entendre pour se prêter leurs livres."
        },
        {
          question: "Les livres peuvent-ils être lus dans l'application ?",
          answer:
            "Non, l'application ne contient pas de livres, seulement les quiz liés à ceux-ci. Les enfants lisent les livres hors ligne puis répondent aux quiz correspondants dans l'application."
        }
      ]
    },
    {
      categoryName: 'Support Technique',
      faqs: [
        {
          question: "J'ai oublié mon nom d'utilisateur. Que dois-je faire ?",
          answer:
            'Vous pouvez connaître votre nom d\'utilisateur en cliquant sur le lien "Nom d\'utilisateur oublié" sur la page de connexion et en suivant les instructions.'
        },
        {
          question: "J'ai oublié mon mot de passe. Que dois-je faire ?",
          answer:
            'Vous pouvez réinitialiser votre mot de passe en cliquant sur le lien "Mot de passe oublié" sur la page de connexion et en suivant les instructions.'
        },
        {
          question: 'Comment puis-je contacter le support client ?',
          answer:
            "Pour tout problème ou question, vous pouvez contacter notre équipe de support client via la section d'aide dans l'application ou en envoyant un e-mail à contact@griffyreads.com."
        }
      ]
    }
  ]
}

export default FR_FAQ_PAGE_CONSTANTS
